import Image from "next/image";
import Link from "next/link";
import { FaAd } from "react-icons/fa";
import { MdCake, MdPhoneAndroid } from "react-icons/md";

export default function ItemHeader({ ...props }) {
  return (
    <div className={`${props.className} flex items-center mb-2`}>
      <div
        className={`flex items-center ${props.isItemBig && "flex-row-reverse"}`}
      >
        <Link
          href={
            props.isAd
              ? "javascript:void(0)"
              : `/g/${encodeURIComponent(props.box.groupe_permalink)}`
          }
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="flex items-center"
        >
          {props.isAd ? (
            <>
              <FaAd className="hidden sm:block h-5 w-5 mr-2 opacity-50" />
              <div className="text-primary text-xs hover:underline">
                Publicité
              </div>
            </>
          ) : (
            <>
              <img
                src={props.box.groupe_icone}
                alt={props.box.groupe_permalink}
                width={30}
                height={30}
                quality={100}
                className="hidden sm:block h-5 w-5 mr-2 rounded-full"
              />
              <div className="text-primary text-xs hover:underline">
                {props.box.groupe_permalink}
              </div>
            </>
          )}
        </Link>
        {!props.isAd && (
          <>
            <div className="text-base-content mx-2 opacity-50">&middot;</div>
            <Link
              href={`/blog/${encodeURIComponent(props.box.membre_permalink)}`}
              onClick={(e) => {
                e.stopPropagation();
              }}
              className={`text-base-content text-xs hover:underline`}
            >
              {props.box.membre_pseudo}
            </Link>
            {props.box.is_birthday ? (
              <>
                <div
                  className="bg-purple-500 ml-1 w-4 h-4 flex items-center justify-center rounded-full"
                  title={props.box.membre_pseudo + " fête son anniversaire !"}
                >
                  <MdCake className="w-3 h-3 text-white" />
                </div>
              </>
            ) : null}
            {props.box.posted_from == "app" && props.box.anonyme == 0 ? (
              <a
                href="https://bit.ly/3CiFOCh"
                target="_blank"
                rel="nofollow noopener noreferrer"
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className="text-base-content"
                title="Posté depuis l'application mobile Android"
              >
                <MdPhoneAndroid className="ml-1 w-3 h-3" />
              </a>
            ) : null}
            {props.box.is_groupe_admin && props.box.anonyme == 0 ? (
              <div
                className="inline-block ml-1 text-xxs leading-4 px-1 bg-admin text-admin-content rounded-full"
                title="Admin"
              >
                a
              </div>
            ) : props.box.is_groupe_moderator && props.box.anonyme == 0 ? (
              <div
                className="inline-block ml-1 text-xxs leading-4 px-1 bg-moderator text-moderator-content rounded-full"
                title="Modérateur"
              >
                m
              </div>
            ) : null}
            {props.box.membre_groupe_icone &&
            props.box.membre_groupe_icone.icone ? (
              <img
                src={props.box.membre_groupe_icone.icone}
                alt={props.box.membre_groupe_icone.description}
                className="ml-1 w-4 h-4 rounded-full"
                title={props.box.membre_groupe_icone.description}
                preload="false"
                lazy="true"
              />
            ) : null}
          </>
        )}
      </div>
      <div className="grow sm:hidden"></div>
      {!props.isAd && (
        <>
          <div className="text-base-content hidden sm:block mx-2 opacity-50">
            &middot;
          </div>
          <Link
            href={`/${encodeURIComponent(props.box.permalink)}`}
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="text-base-content text-xs hover:underline"
            title={props.box.date_full}
          >
            {props.box.date}
          </Link>
        </>
      )}
    </div>
  );
}
